import { useEffect, useMemo, useState } from "react";

export function useSyncedState<T>(
  parentState: T | undefined,
  setParentState: ((value: T) => void) | undefined,
  defaultValue: T,
) {
  const [internalState, setInternalState] = useState<T>(defaultValue);

  const state = useMemo(
    () => (parentState !== undefined ? parentState : internalState),
    [parentState, internalState],
  );

  const setState = useMemo(
    () => (value: T) => {
      setInternalState(value);
      setParentState?.(value);
    },
    [setParentState],
  );

  useEffect(() => {
    if (parentState === undefined) return;
    setInternalState(parentState);
  }, [parentState, setInternalState]);

  return [state, setState] as const;
}
